var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9434 32C25.7799 32 32.9434 24.8366 32.9434 16C32.9434 7.16344 25.7799 0 16.9434 0C8.1068 0 0.943359 7.16344 0.943359 16C0.943359 24.8366 8.1068 32 16.9434 32Z",
    fill: "#5A99EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.26 24.0112C20.9563 24.0112 24.6185 18.4621 24.6185 13.6527C24.6185 13.4938 24.6162 13.3374 24.6091 13.181C25.3202 12.6666 25.9388 12.0266 26.4248 11.2965C25.7729 11.5857 25.0713 11.7824 24.3341 11.8701C25.0855 11.4198 25.6639 10.7063 25.9341 9.85533C25.2301 10.2725 24.4526 10.5759 23.623 10.7395C22.9593 10.0307 22.0135 9.58984 20.9658 9.58984C18.9557 9.58984 17.3249 11.2207 17.3249 13.2307C17.3249 13.5175 17.3581 13.7949 17.4197 14.0604C14.3928 13.9087 11.7095 12.4604 9.91514 10.2559C9.60225 10.794 9.4221 11.4198 9.4221 12.0858C9.4221 13.3493 10.0645 14.4633 11.0434 15.1175C10.4461 15.0986 9.88432 14.935 9.39366 14.6624C9.39366 14.6767 9.39366 14.6933 9.39366 14.7098C9.39366 16.4734 10.65 17.9454 12.314 18.2796C12.0082 18.3626 11.6858 18.4076 11.354 18.4076C11.1193 18.4076 10.8917 18.3839 10.6689 18.3413C11.1335 19.7872 12.4775 20.8396 14.0704 20.8704C12.8236 21.847 11.2544 22.4278 9.54773 22.4278C9.25381 22.4278 8.96462 22.4112 8.68018 22.378C10.292 23.4115 12.2049 24.0135 14.26 24.0135",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.943359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.4b082d1d01a3d505e0194075299a6901.svg";
export { ForwardRef as ReactComponent };